import React, {Component} from 'react';
import {Route, Switch, Redirect} from "react-router-dom";

//路由
import WeChatLogin from './WeChatLogin';
import Home from './Home';
import Security from './Home/Security';//安全中心
import RideCar from './Home/RideCar';//城内立即叫车
import RideCarPay from './Home/RideCarPay';//城内立即叫车
import SelAddress from './Home/SelAddress';//选择地址
import CitySelAddress from './Home/CitySelAddress';//选择地址
import SelectShift from './Home/SelectShift';//班次列表（改签同用）
import SelectSeat from './Home/SelectSeat';//座位选择
import SelectSeatSpecial from './Home/SelectSeatSpecial';//座位选择
import UserAgreement from './Home/UserAgreement';//用户协议详情
import Jumppage from './Home/Jumppage';//用户协议详情
import PayFinish from './Home/PayFinish';//支付完成是否去完善信息
import PerfectionInfo from './Home/PerfectionInfo';//完善身份信息
import PrinceActive from './Home/PrinceActive';//学车小王子活动页
import GoodsInfo from './Home/GoodsInfo';//带货下单页
import Member from '../container/member';//个人中心
import ApplyInvoice from './Invoice/ApplyInvoice';//发票选项
import Invoice from '../container/Invoice';//发票列表
import InvoiceInfo from './Invoice/InvoiceInfo'//发票申请
import InvoiceSucceed from './Invoice/InvoiceSucceed'//发票申请成功
import paperInvoice from './Invoice/paperInvoice';//电子纸质发票详情
import InvoiceHistory from './Invoice/InvoiceHistory'// 发票历史
import MyOrder from '../container/member/MyOrder';//我的订单
import OrderDetail from './Order/OrderDetail';//订单详情
import EditPassengerInfo from './Order/EditPassengerInfo';//订单详情修改乘客信息
import GradeDriver from './member/GradeDriver';//评价
import Refund from './member/MyOrder/refund';//退款详情
import OrderChange from './Order/OrderChange';//改签选座位
import Discounts from '../container/member/Discounts';//优惠券列表
import DiscountsInfo from '../container/member/Discounts/DiscountsInfo';//优惠券详情
import ExchangeCoupon from '../container/member/ExchangeCoupon';//领取优惠券
import Contacts from './member/Contacts';//紧急联系人
import OftenPassenger from '../container/member/OftenPassenger';//常用乘车人列表
import AddOftenPsg from '../container/member/AddOftenPsg';//添加常用乘车人
import Suggestion from '../container/member/Suggestion';//意见反馈
import Cancellation from '../container/member/Cancellation';//注销账号
import CancelUserCode from '../container/member/CancelUserCode';//注销账号获取手机号
import GetDiscount from '../container/GetDiscount';//领取优惠券
import GetCoupon from '../container/GetCoupon';//领取优惠券2
import Promote from '../container/member/Promote';//推广返利
import WalletInfo from '../container/member/Promote/WalletInfo';//查看邀请开通钱包数量
import EndOrder from '../container/member/Promote/EndOrder';//业绩查询
import Rebate from '../container/member/Promote/Rebate';//返利明细
import Wallet from '../container/member/Wallet';//我的钱包
import Account from '../container/member/Wallet/Account';//钱包账户
import AccountInfo from '../container/member/Wallet/AccountInfo';//钱包明细
import Recharge from '../container/member/Wallet/Recharge';//钱包充值提现
import BankCard from '../container/member/Wallet/BankCard';//钱包银行卡管理
import AddBankCard from '../container/member/Wallet/AddBankCard';//钱包添加银行卡
import DiscountPackage from '../container/member/DiscountPackage';//优惠套餐
import PackageInfo from '../container/member/DiscountPackage/PackageInfo';//优惠套餐详情

//帮助中心
import HelpCenter from '../container/member/HelpCenter';
import AboutMintu from '../container/member/HelpCenter/AboutMintu';
import InvoiceApply from '../container/member/HelpCenter/InvoiceApply';
import RidingKnow from '../container/member/HelpCenter/RidingKnow';
import TicketRefund from '../container/member/HelpCenter/TicketRefund';
import LinePrice from '../container/member/HelpCenter/LinePrice';
import RealName from '../container/member/HelpCenter/RealName';
import ChildInfo from '../container/member/HelpCenter/ChildInfo';
import IdentityBinding from '../container/IdentityBinding';//绑定身份司机或调度


//分享好友
import Share from '../container/member/Share';
import Regulation from '../container/member/Regulation';
import InviteAdd from '../container/member/InviteAdd'

import Activity from '../container/Activity';//折扣线路
import LineActivity from '../container/LineActivity';//线路活动
import InvoiceProtocol from './Invoice/InvoiceProtocol'//开具发票协议
//查询订单页
import SearchOrderList from '../container/SearchOrderList';
import SearchOrderDetail from '../container/SearchOrderList/SearchOrderDetail';
import Vote from '../container/Vote';
import MtLife from '../container/MtLife';
import FileDetail from '../container/MtLife/FileDetail';
import RecruitDrivers from '../container/IdentityBinding/RecruitDrivers';
import Empty from './Home/Empty';

export default class App extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }


    render() {
        return (
            <Switch>
                <Route path="/empty" component={Empty}/>
                <Route path="/fileDetail/:id" component={FileDetail}/>
                <Route path="/mtLife" component={MtLife}/>
                <Route path="/vote" component={Vote}/>
                <Route path="/searchOrderList" component={SearchOrderList}/>
                <Route path="/searchOrderDetail/:id" component={SearchOrderDetail}/>
                <Route path="/invoiceProtocol" component={InvoiceProtocol}/>
                <Route path="/recruitDrivers" component={RecruitDrivers}/>

                <Route path="/childInfo" component={ChildInfo}/>
                <Route path="/realName" component={RealName}/>
                <Route path="/linePrice" component={LinePrice}/>
                <Route path="/invoiceApply" component={InvoiceApply}/>
                <Route path="/ticketRefund" component={TicketRefund}/>
                <Route path="/ridingKnow" component={RidingKnow}/>
                <Route path="/aboutMintu" component={AboutMintu}/>
                <Route path="/pay/activity" component={Activity}/>
                <Route path="/lineActivity" component={LineActivity}/>
                <Route path="/regulation" component={Regulation}/>
                <Route path="/inviteAdd" component={InviteAdd}/>
                <Route path="/share" component={Share}/>
                {/*<Route path="/icbcBank" component={IcbcBank}/>*/}


                <Route path="/packageInfo/:id" component={PackageInfo}/>
                <Route path="/discountPackage" component={DiscountPackage}/>
                <Route path="/addBankCard" component={AddBankCard}/>
                <Route path="/bankCard" component={BankCard}/>
                <Route path="/recharge" component={Recharge}/>
                <Route path="/accountInfo" component={AccountInfo}/>
                <Route path="/account" component={Account}/>
                <Route path="/wallet" component={Wallet}/>
                <Route path="/walletInfo" component={WalletInfo}/>
                <Route path="/endOrder" component={EndOrder}/>
                <Route path="/rebate" component={Rebate}/>
                <Route path="/promote" component={Promote}/>
                <Route path="/getCoupon/:id" component={GetCoupon}/>
                <Route path="/getDiscount" component={GetDiscount}/>
                <Route path="/identityBinding" component={IdentityBinding}/>
                <Route path="/helpCenter" component={HelpCenter}/>
                <Route path="/suggestion" component={Suggestion}/>
                <Route path="/cancellation" component={Cancellation}/>
                <Route path="/cancelUserCode" component={CancelUserCode}/>
                <Route path="/oftenPassenger" component={OftenPassenger}/>
                <Route path="/addOftenPsg" component={AddOftenPsg}/>
                <Route path="/contacts" component={Contacts}/>
                <Route path="/exchangeCoupon" component={ExchangeCoupon}/>
                <Route path="/discountsInfo/:id" component={DiscountsInfo}/>
                <Route path="/discounts" component={Discounts}/>
                <Route path="/paperInvoice/:id" component={paperInvoice}/>
                <Route path="/invoiceHistory" component={InvoiceHistory}/>
                <Route path="/invoiceSucceed" component={InvoiceSucceed}/>
                <Route path="/pay/invoiceInfo" component={InvoiceInfo}/>
                <Route path="/invoice" component={Invoice}/>
                <Route path="/applyInvoice" component={ApplyInvoice}/>
                <Route path="/pay/orderChange" component={OrderChange}/>
                <Route path="/refund" component={Refund}/>
                <Route path="/gradeDriver" component={GradeDriver}/>
                <Route path="/orderDetail/:id" component={OrderDetail}/>
                <Route path="/editPassengerInfo" component={EditPassengerInfo}/>
                <Route path="/pay/myOrder" component={MyOrder}/>
                <Route path="/pay/myPage" component={Member}/>
                <Route path="/perfectionInfo/:id" component={PerfectionInfo}/>
                <Route path="/payFinish/:id" component={PayFinish}/>
                <Route path="/goodsInfo" component={GoodsInfo}/>
                <Route path="/princeActive" component={PrinceActive}/>
                <Route path="/userAgreement" component={UserAgreement}/>
                <Route path="/jumppage" component={Jumppage}/>
                <Route path="/pay/selectSeat" component={SelectSeat}/>
                <Route path="/pay/SelectSeatSpecial" component={SelectSeatSpecial}/>
                <Route path="/selectShift" component={SelectShift}/>
                <Route path="/selAddress" component={SelAddress}/>
                <Route path="/citySelAddress" component={CitySelAddress}/>
                <Route path="/rideCar" component={RideCar}/>
                <Route path="/RideCarPay" component={RideCarPay}/>
                <Route path="/security" component={Security}/>
                <Route path="/pay/home" component={Home}/>
                <Route path="/pay/:typeName" component={WeChatLogin}/>
                <Route path="/" render={() => <Redirect to="/pay/homepage"/>}/>
            </Switch>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/App.js